export function DetectingPageCountBanner() {
  return (
    <section className="bg-surface-lowest rounded-4 shadow-kiosk-sm p-3 d-flex align-items-center gap-3 mt-3">
      <span className="spinner-border spinner-border-sm text-primary flex-shrink-0" role="status" aria-hidden="true" />
      <div className="d-flex flex-column">
        <span className="text-label-md text-on-surface">Counting pages…</span>
        <span className="text-body-sm text-on-surface-variant">
          Reading your PDF locally to calculate exact pricing.
        </span>
      </div>
    </section>
  );
}
